<template>
  <div class="google-map--wrap">
    <div class="google-map--title" v-if="title">
      {{ title }}
    </div>
    <div class="google-map--basic" ref="googleMap"></div>
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader'
// TODO: replace mapStyles with real data
import mapStyles from './mapStyles.json'

export default {
  name: 'Map',
  data: () => ({
    google: null,
    map: null,
    markers: [],
    mapOptions: {
      zoom: 11,
      center: {
        lat: null,
        lng: null
      },
      zoomControl: true,
      disableDefaultUI: true,
      scrollwheel: false,
      mapTypeId: 'Styled',
      mapTypeControl: false,
      draggable: true,
      zoomControlOptions: { position: null }
    },
    // TODO: take api key from env?
    apiKey: 'AIzaSyDP9-Ef5Li4eyrSao_7kifAnmZzDuRZocY'
  }),
  props: ['data', 'title'],
  components: {
  },
  computed: {
  },
  async mounted () {
    const loader = await new Loader({
      apiKey: this.apiKey
    })
    this.google = await loader.load()
    this.google = window.google
    this.initMap()
  },
  created () {
    this.mapOptions.center.lat = parseFloat(this.data.lat)
    this.mapOptions.center.lng = parseFloat(this.data.lng)
  },
  methods: {
    initMap () {
      const mapContainer = this.$refs.googleMap
      this.map = new self.google.maps.Map(mapContainer, this.mapOptions)
      var styledMapType = new this.google.maps.StyledMapType(mapStyles, {
        name: 'Styled'
      })
      this.map.mapTypes.set('Styled', styledMapType)
      this.initMarkers()
    },
    initMarkers () {
      for (var i = 0; i < 1; i++) {
        var latLng = new this.google.maps.LatLng(parseFloat(this.data.lat),
          parseFloat(this.data.lng))

        var image = {
          url: require('../../images/search/marker.svg'),
          scaledSize: new this.google.maps.Size(25, 34)
        }
        // Offset markers in same position
        var finalLatLng = new this.google.maps.LatLng(latLng.lat(), latLng.lng())
        var marker = new this.google.maps.Marker({
          position: finalLatLng,
          icon: image
        })

        this.markers.push(marker)
      }
      // Add markers to map
      for (var s = 0; s < this.markers.length; s++) {
        this.markers[s].setMap(this.map)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../scss/global/includes";

.google-map--wrap {
  margin: 0;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
}
.google-map--basic, .google-map--basic * {
  outline: none;
}
.google-map--basic {
  width: 100%;
  position: relative;
  aspect-ratio: 3.5/2;
}
.google-map--title {
  width: 100%;
  display: block;
  font-size: 14px;
  color: $primary;
  text-transform: uppercase;
  font-family: $font-regular;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid $mid-light;
  letter-spacing: -0.2px
}
</style>
